import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import type { PendingComments } from './types';

import { safeLocalStorage } from '@/lib/safe-storage';

type PendingCommentsState = {
  pendingComments: PendingComments[];
  addPendingComment: (comment: PendingComments) => void;
  removePendingComment: (commentId: number) => void;
  clearPendingComments: (commentsToClear?: PendingComments[]) => void;
  editPendingComment: (commentId: number, content: string) => void;
};

export const usePendingCommentsStore = create<PendingCommentsState>()(
  persist(
    (set) => ({
      pendingComments: [],
      addPendingComment: (comment) => {
        if (!comment.content.trim()) {
          return;
        }
        set((state) => ({
          pendingComments: [...state.pendingComments, comment],
        }));
      },
      removePendingComment: (commentId) =>
        set((state) => ({
          pendingComments: state.pendingComments.filter((c) => c.id !== commentId),
        })),
      editPendingComment: (commentId, content) => {
        if (!content.trim()) {
          return;
        }
        set((state) => ({
          pendingComments: state.pendingComments.map((c) =>
            c.id === commentId ? { ...c, content } : c,
          ),
        }));
      },
      clearPendingComments: (commentsToClear) =>
        set((state) => {
          if (!commentsToClear) {
            return { pendingComments: [] };
          }
          const commentIdsToClear = new Set(commentsToClear.map((c) => c.id));
          return {
            pendingComments: state.pendingComments.filter((c) => !commentIdsToClear.has(c.id)),
          };
        }),
    }),
    {
      name: 'pending-comments-storage-foo2',
      storage: createJSONStorage(() => safeLocalStorage),
    },
  ),
);
